import React, { useState } from "react";
import "./CustomDesignation.scss";

export default function CustomDesignation() {
  const [isValid, setIsValid] = useState(true);
  const [isEmpty, setIsEmpty] = useState(true);

  function onChangeCustomDesignation(e) {
    const value = e.target.value;
    setIsValid(value.length <= 400);
    setIsEmpty(!value.length || value.length < 4);
  }

  return (
    <div className="custom-designation coh-style-container-theme---dark-1">
      <form className="custom-designation__form" action="/give" method="get">
        <div>
          <img
            width="90"
            src="/modules/custom/emoryaae_donations/js/react/src/assets/EmoryCare.svg"
            alt="Custom fund"
          />
        </div>
        <h3 className="custom-designation__title">
          Can't find what <br /> you're looking for?
        </h3>
        <label
          className={`custom-designation__form-control ${
            !isValid ? "has-errors" : ""
          }`}
        >
          <span className="custom-designation__form-control-label">
            Tell us what you want to support:
          </span>
          <input
            type="text"
            className="custom-designation__input"
            name="to"
            placeholder="Enter a designation."
            onChange={onChangeCustomDesignation}
          />
          {(!isValid && (
            <span
              role="alert"
              className="help-tip help-tip--top-left help-tip--custom-designation"
            >
              Maximum length is 400 characters
            </span>
          )) ||
            null}
        </label>

        <div className="custom-designation__button-container">
          <button
            type="submit"
            className="coh-style-link-button-with-icon"
            disabled={!isValid || isEmpty}
          >
            Give now
          </button>
        </div>
      </form>
    </div>
  );
}
